import { Controller } from "@hotwired/stimulus"

// Cookie/privacy banner. Renders persistently until the visitor dismisses
// it; dismissal is remembered in localStorage so the banner doesn't appear
// again on subsequent visits from the same browser.
//
// Expected markup:
//   <div data-controller="cookie-banner"
//        data-cookie-banner-key-value="ayearonthefarm-cookie-ack"
//        class="hidden">
//     …banner content…
//     <button data-action="click->cookie-banner#dismiss">OK</button>
//   </div>
export default class extends Controller {
  static values = { key: { type: String, default: "site-cookie-ack" } }

  connect() {
    if (this._dismissed()) return
    this.element.classList.remove("hidden")
  }

  dismiss() {
    try {
      window.localStorage.setItem(this.keyValue, "1")
    } catch (_e) {
      // localStorage might be blocked (private mode, strict cookie settings).
      // Fall back to hiding for this session only.
    }
    this.element.classList.add("hidden")
  }

  _dismissed() {
    try {
      return window.localStorage.getItem(this.keyValue) === "1"
    } catch (_e) {
      return false
    }
  }
}
